import "core-js/modules/es6.array.find-index";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.is-array";
export default function getNewValue(value, oldValue, multiple) {
  if (!multiple) {
    return value;
  }

  var newValue = null;

  if (oldValue && !Array.isArray(oldValue)) {
    newValue = [oldValue];
  } else if (!oldValue) {
    newValue = [];
  } else {
    newValue = _toConsumableArray(oldValue);
  }

  var valueIndex = newValue.findIndex(function (val) {
    return val === value;
  });

  if (valueIndex >= 0) {
    newValue.splice(valueIndex, 1);
  } else {
    newValue.push(value);
  }

  return newValue;
}